import _ from "lodash";
import moment from "moment";
import FilterRefundList from "./FilterList";
import FilterPaymentList from "./FilterList";

const DATA = (results, refund, item) => {
	if (results !== undefined && refund !== undefined && item !== undefined) {
		var payment = FilterPaymentList(results, item);
		var refunds = FilterRefundList(refund, item);
	}

	var datesToCheck = (payments, refunds, cmpareCB) => {
		var dates = payments;
		for (let i = 0; i < payments.length; i++) {
			for (let j = 0; j < refunds.length; j++) {
				if (cmpareCB(payments[i], refunds[j])) {
					_.pull(dates, payments[i]);
				}
			}
		}
		return dates;
	};

	var filterRefund = (p, r) => {
		if (
			p.id === r.refundIdFromTable &&
			p.table_type === r.refundFromTable &&
			p.tool_id === r.tool_id &&
			moment(p.date_from).isSame(r.date_from) &&
			moment(p.date_to).isSame(r.date_to)
		) {
			return true;
		} else if (
			p.id === r.refundIdFromTable &&
			p.table_type === r.refundFromTable &&
			p.tool_id === r.tool_id &&
			p.date_from === "N/A" &&
			p.date_to === "N/A"
		) {
			return true;
		} else {
			return false;
		}
	};

	return datesToCheck(payment, refunds, filterRefund);
};

export default DATA;
